import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TitleCasePipe } from '@angular/common';
import { AuthenticationService } from '../../../security/authentication.service';
import { LayoutService } from '../../../services/layout.service';
import { GlobalService } from 'src/app/services/global.service';
import { AlertService } from 'src/app/services/alert.service';
import { ExpirationDateService } from 'src/app/security/expiration-date.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public sidebarIsOpen: boolean = false;
  public userMenuIsOpen: boolean = false;
  public user: any;
  public _userPermissions: any;


  constructor(
    public authService: AuthenticationService,
    public titleService: Title,
    private titleCase: TitleCasePipe,
    private layoutService: LayoutService,
    public globalService: GlobalService,
    public alertService: AlertService,
    public expirationService: ExpirationDateService
  ) {
    this._userPermissions = this.globalService.getUserPermissionsConst();
  }

  ngOnInit() {
    this.user = this.authService.getLoggedInUser();
    const title = this.authService.getTenantDisplayName();

    this.titleService.setTitle(
      title ? this.titleCase.transform(title) : 'Sire 2'
    );

    // Subscribe to layout service changes
    this.layoutService.sidebarChange.subscribe(isExpanded => {
      this.sidebarIsOpen = isExpanded;
    });

    this.layoutService.userMenuChange.subscribe(isExpanded => {
      this.userMenuIsOpen = isExpanded;
    });
  }

  /**
   * Toggle sidebar on hamburguer click
   */
  toggleSidebar() {
    this.layoutService.toggleSidebar();
  }

  /**
   * Toggle user menu
   */
  toggleUserMenu() {
    this.layoutService.toggleUserMenu();
  }

  /**
   * Return tenant path
   */
  public getTenantPath() {
    let returnTo = this.authService.getTenantName();

    const permission = this._userPermissions.SCREEN_CLIENT_DOCUMENTS;
    if (!this.user.isadmin && this.authService.hasPermission(permission)) {
      returnTo = returnTo + '/externalViewer';
    }

    return `/${returnTo}`;
  }
}
